/**
 * @function guid
 * @desc Creates a random 4 letter string with number and characters
 *
 * @return {string} creates a random 4 letter string with number and characters
 *
 */

const guid = (): string =>
  Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);

export default guid;
